<template>
  <div>
    <div class="columns">
      <div class="column is-12-mobile is-12-desktop is-12-widescreen p-x-0">
        <div class="level">
          <div class="level-left">
            <div class="title is-marginless is-paddingless">Users</div>
          </div>
        </div>
      </div>
    </div>
    <div class="columns">
      <div class="column is-12 is-paddingless">
        <div class="tabs is-boxed">
          <ul>
            <li :class="{'is-active': isActiveTab('reviewersListing') || isActiveTab('reviewers')}">
              <a :href="'/users-list/reviewers'"><span>Reviewers</span></a>
            </li>
            <li :class="{'is-active': isActiveTab('businessUsers')}">
              <a :href="'/users-list/business-users'"><span>Business Users</span></a>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <keep-alive>
      <router-view name="reviewers"></router-view>
    </keep-alive>
    <keep-alive>
      <router-view name="businessUsers"></router-view>
    </keep-alive>
  </div>
</template>

<script>
  /* eslint-disable indent,no-new,no-undef,no-unused-expressions, no-useless-escape */
  import misc from '../../mixins/misc.js'

  export default {
    mixins: [misc],
    data () {
      return {}
    },
    methods: {
      isActiveTab (tab) {
        return this.openActiveTabForURL(this.$router.currentRoute.name, tab)
      }
    }
  }
</script>

<style scoped>
  .table td, .table th {
    border: none;
  }

  .table > tbody > tr {
    background-color: #f5f5f5 !important;
    margin-bottom: 10px;
  }

  .table > tbody > td {
    margin-bottom: 20px;
  }

  tr.goto-business {
    cursor: pointer;
  }

  .tabs li.is-active a {
    color: #2aabe1 !important;
  }
</style>


// WEBPACK FOOTER //
// src/pages/users/UsersLayout.vue